import { Reducer } from "redux";

import { MasterRoleResponse } from "../models/api/User";
import { MasterRoleDispatchTypes } from "../models/dispatchTypes/User";
import { MasterRoleActionDispatchTypes } from "../constants/User";

const initialState: MasterRoleResponse = {
  loading: false,
  response: [],
  error: null
};

const MasterRoleReducer: Reducer<
MasterRoleResponse,
MasterRoleDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case MasterRoleActionDispatchTypes.ROLE_LOADING: {
      return {
        ...state,
        loading: true,
      };
    }
    case MasterRoleActionDispatchTypes.ROLE_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
  }
  return state;
};

export default MasterRoleReducer;
